export default [
  {
    date: 1543929374457,
    row: 31,
    col: 31,
    segments: [
      [1, 1, 31, 31],
      [1, 31, 31, 1],
      [1, 1, 17, 15],
      [17, 15, 31, 31],
      [31, 31, 15, 17],
      [15, 17, 1, 1],
      [2, 2, 18, 14],
      [18, 14, 30, 30],
      [30, 30, 14, 18],
      [14, 18, 2, 2],
      [3, 3, 19, 13],
      [19, 13, 29, 29],
      [29, 29, 13, 19],
      [13, 19, 3, 3],
      [4, 4, 20, 12],
      [20, 12, 28, 28],
      [28, 28, 12, 20],
      [12, 20, 4, 4],
      [5, 5, 21, 11],
      [21, 11, 27, 27],
      [27, 27, 11, 21],
      [11, 21, 5, 5],
      [6, 6, 22, 10],
      [22, 10, 26, 26],
      [26, 26, 10, 22],
      [10, 22, 6, 6],
      [7, 7, 23, 9],
      [23, 9, 25, 25],
      [25, 25, 9, 23],
      [9, 23, 7, 7],
      [8, 8, 24, 8],
      [24, 8, 24, 24],
      [24, 24, 8, 24],
      [8, 24, 8, 8],
      [9, 9, 25, 7],
      [25, 7, 23, 23],
      [23, 23, 7, 25],
      [7, 25, 9, 9],
      [10, 10, 26, 6],
      [26, 6, 22, 22],
      [22, 22, 6, 26],
      [6, 26, 10, 10],
      [11, 11, 27, 5],
      [27, 5, 21, 21],
      [21, 21, 5, 27],
      [5, 27, 11, 11],
      [12, 12, 28, 4],
      [28, 4, 20, 20],
      [20, 20, 4, 28],
      [4, 28, 12, 12],
      [13, 13, 29, 3],
      [29, 3, 19, 19],
      [19, 19, 3, 29],
      [3, 29, 13, 13],
      [14, 14, 30, 2],
      [30, 2, 18, 18],
      [18, 18, 2, 30],
      [2, 30, 14, 14],
      [15, 15, 31, 1],
      [31, 1, 17, 17],
      [17, 17, 1, 31],
      [1, 31, 15, 15],
      [16, 1, 16, 31],
      [31, 16, 1, 16],
      [16, 1, 17, 16],
      [16, 2, 18, 16],
      [16, 3, 19, 16],
      [16, 4, 20, 16],
      [16, 5, 21, 16],
      [16, 6, 22, 16],
      [16, 7, 23, 16],
      [16, 8, 24, 16],
      [16, 9, 25, 16],
      [16, 10, 26, 16],
      [16, 11, 27, 16],
      [16, 12, 28, 16],
      [16, 13, 29, 16],
      [16, 14, 30, 16],
      [16, 15, 31, 16],
      [16, 31, 17, 16],
      [16, 31, 15, 16],
      [15, 16, 16, 1],
      [18, 16, 16, 30],
      [16, 30, 14, 16],
      [14, 16, 16, 2],
      [19, 16, 16, 29],
      [16, 29, 13, 16],
      [13, 16, 16, 4],
      [20, 16, 16, 28],
      [16, 28, 12, 16],
      [12, 16, 16, 5],
      [21, 16, 16, 27],
      [16, 27, 11, 16],
      [11, 16, 16, 6],
      [22, 16, 16, 26],
      [16, 26, 10, 16],
      [10, 16, 16, 7],
      [23, 16, 16, 25],
      [16, 25, 9, 16],
      [9, 16, 16, 8],
      [16, 24, 24, 16],
      [16, 24, 8, 16],
      [8, 16, 16, 8],
      [25, 16, 16, 23],
      [16, 23, 7, 16],
      [7, 16, 16, 9],
      [26, 16, 16, 22],
      [16, 22, 6, 16],
      [6, 16, 16, 10],
      [27, 16, 16, 21],
      [16, 21, 5, 16],
      [5, 16, 16, 11],
      [28, 16, 16, 20],
      [16, 20, 4, 16],
      [4, 16, 16, 12],
      [29, 16, 16, 19],
      [16, 19, 3, 16],
      [3, 16, 16, 13],
      [30, 16, 16, 18],
      [16, 18, 2, 16],
      [2, 16, 16, 14],
      [31, 16, 16, 17],
      [16, 17, 1, 16],
      [1, 16, 16, 15],
      [31, 16, 30, 1],
      [31, 15, 29, 1],
      [31, 14, 28, 1],
      [31, 13, 27, 1],
      [31, 12, 26, 1],
      [31, 11, 25, 1],
      [31, 10, 24, 1],
      [31, 9, 23, 1],
      [31, 8, 22, 1],
      [31, 7, 21, 1],
      [31, 6, 20, 1],
      [31, 5, 19, 1],
      [31, 4, 18, 1],
      [31, 3, 17, 1],
      [31, 2, 16, 1],
      [31, 16, 31, 1],
      [31, 1, 16, 1],
      [31, 16, 30, 31],
      [31, 17, 29, 31],
      [31, 18, 28, 31],
      [31, 19, 27, 31],
      [31, 20, 26, 31],
      [31, 21, 25, 31],
      [31, 22, 24, 31],
      [31, 23, 23, 31],
      [31, 24, 22, 31],
      [31, 25, 21, 31],
      [31, 26, 20, 31],
      [31, 27, 19, 31],
      [31, 28, 18, 31],
      [31, 29, 17, 31],
      [31, 30, 16, 31],
      [31, 16, 31, 31],
      [31, 31, 16, 31],
      [1, 16, 2, 31],
      [1, 17, 3, 31],
      [1, 18, 4, 31],
      [1, 19, 5, 31],
      [1, 20, 6, 31],
      [1, 21, 7, 31],
      [1, 22, 8, 31],
      [1, 23, 9, 31],
      [1, 24, 10, 31],
      [1, 25, 11, 31],
      [1, 26, 12, 31],
      [1, 27, 13, 31],
      [1, 28, 14, 31],
      [1, 29, 15, 31],
      [1, 30, 16, 31],
      [1, 16, 2, 1],
      [1, 15, 3, 1],
      [1, 14, 4, 1],
      [1, 13, 5, 1],
      [1, 12, 6, 1],
      [1, 11, 7, 1],
      [1, 10, 8, 1],
      [1, 9, 9, 1],
      [1, 8, 10, 1],
      [1, 7, 11, 1],
      [1, 6, 12, 1],
      [1, 5, 13, 1],
      [1, 4, 14, 1],
      [1, 3, 15, 1],
      [1, 2, 16, 1],
      [16, 1, 1, 1],
      [1, 1, 1, 31],
      [1, 31, 16, 31]
    ]
  }
];
